import React, { useState } from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import alphaLogo from '../../assets/logo.png';
import { Button } from '@/components/ui/button';

const Footer: React.FC = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = () => {
    // Handle newsletter subscription
    console.log('Subscribe:', email);
  };

  return (
    <footer className="bg-black text-white rounded-t-[32px]">
      <div className="mx-auto px-4 sm:px-8 lg:px-16 xl:px-24 py-20">
        <div className='flex gap-x-[56px]'>
          {/* Newsletter Section */}
          <div className="items-center justify-between gap-8 mb-12">
            <div className='flex bg-[#202324] px-6 py-4 rounded-[12px] mb-[30px]'>
              <div className='pr-5'>
                <h3
                  className="text-white mb-2"
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '32px',
                    fontWeight: 700,
                    lineHeight: '40px'
                  }}
                >
                  Register Now So You
                </h3>
                <h3
                  className="text-white"
                  style={{
                    fontFamily: 'Poppins',
                    fontSize: '32px',
                    fontWeight: 700,
                    lineHeight: '40px'
                  }}
                >
                  Don't Miss Our NEWS!
                </h3>
              </div>

              <div className="flex gap-3 w-full lg:w-auto items-center bg-white rounded-[10px] px-3">
                <div className='border-2 border-[#99A2A5] rounded-[10px] flex-1'>
                  <input
                    type="email"
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="flex-1 lg:w-[400px] px-6 py-4 rounded-xl bg-white text-gray-900 focus:outline-none"
                    style={{
                      fontFamily: 'Inter',
                      fontSize: '16px',
                      fontWeight: 400
                    }}
                  />
                </div>
                <div>
                  <Button
                    onClick={handleSubscribe}
                    className='h-14'
                    style={{
                      fontFamily: 'Poppins',
                      fontSize: '16px',
                      fontWeight: 600
                    }}
                  >
                    Subcribe Now
                  </Button>
                </div>
              </div>
            </div>
            {/* Contact Info */}
            <div className="space-y-3 mb-12">
              <div className="flex items-start gap-3 text-gray-300">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400
                  }}
                >
                  WS 3, 7/F, Cyberport Smart-Space Proptech, 5 Lok Tip Road, Fanling, NT
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Phone className="w-5 h-5 flex-shrink-0" />
                <span
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400
                  }}
                >
                  +852 9460 5454
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-300">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400
                  }}
                >
                  Desmond@alphaaiauto.com
                </span>
              </div>
            </div>
          </div>
          <div className="hidden lg:flex lg:flex-col lg:h-full">
            {/* Quick Links */}
            <h4
              className="text-white mb-20 mt-6"
              style={{
                fontFamily: 'Poppins',
                fontSize: '20px',
                fontWeight: 600
              }}
            >
              Quick Links
            </h4>
            <ul className="flex flex-col flex-1 gap-y-[10px]">
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition-colors"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400
                  }}
                >
                  Discover Campsites
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition-colors"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400
                  }}
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition-colors"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400
                  }}
                >
                  Reviews
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-300 hover:text-white transition-colors"
                  style={{
                    fontFamily: 'Inter',
                    fontSize: '16px',
                    fontWeight: 400
                  }}
                >
                  Help Center
                </a>
              </li>
            </ul>
          </div>
        </div>
        


        {/* Divider */}
        <div className="border-t border-gray-800 mb-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          <div
            className="text-gray-300"
            style={{
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: 400
            }}
          >
            © 2025 Alpha AI Technology. All rights reserved.
          </div>

          <div className="flex items-center gap-2">
            <img src={alphaLogo} alt="Alpha AI" className="h-8 w-auto" />
          </div>

          <div className="flex gap-8">
            <a
              href="#"
              className="text-gray-300 hover:text-white transition-colors"
              style={{
                fontFamily: 'Inter',
                fontSize: '14px',
                fontWeight: 400
              }}
            >
              Terms of Service
            </a>
            <a
              href="#"
              className="text-gray-300 hover:text-white transition-colors"
              style={{
                fontFamily: 'Inter',
                fontSize: '14px',
                fontWeight: 400
              }}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;